import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { memo } from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Drawer from '@mui/material/Drawer';
import { setDrawerIsOpenThunk } from './../../store/drawerMenu';
import { ParticlesAnimation } from '../ParticlesAnimation';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { startResetAllBusinessSlices } from '../../store/agreement';
import { URLRoutes } from '../../config';
import i18n from '../../config/lang';

export const BtnHelp = memo(( { drawerIsOpen } ) => {
    const { i18n: i18nHook } = useTranslation();
    const t = i18nHook.t;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const toggleDrawer = (newOpen) => () => {
        dispatch(setDrawerIsOpenThunk(newOpen));
    };

    const changeLanguage = (language) => {
        i18nHook.changeLanguage(language);
        i18n.changeLanguage(language);
        toggleDrawer(false)();
        navigate(location.pathname, { replace: true });
    }

    const resetApp = async() => {
        await dispatch( startResetAllBusinessSlices() );
        navigate(URLRoutes.clientHome());
        toggleDrawer(false)();
    }

    return (
        <>
            <div className='btn btn-button-layout btn-small'>
                <div className='button-shadow'></div>
                <span onClick={toggleDrawer(true)}> ? </span>
            </div>
            <Drawer open={drawerIsOpen} onClose={toggleDrawer(false)} className='drawer-wrapper'>
                <Box className='layout-bg' sx={{ width: '50vw' }} role="presentation">
                    <i
                        onClick={toggleDrawer(false)}
                        className="far fa-times-circle btn-close-menu"
                    ></i>
                    <div className="fade-overlay">
                        <ParticlesAnimation />
                    </div>
                    <List className='d-flex align-content-end flex-wrap text-drawer-menu'>
                        <ListItem key='Ayuda' disablePadding>
                            <ListItemButton disableRipple>
                                <i className="fas fa-question-square"></i>
                                <ListItemText primary={t('App.Components.help')} primaryTypographyProps={{ fontSize: 'min(2.4vh, 2.4vw)', fontWeight: 300 }} />
                            </ListItemButton>
                        </ListItem>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                gap: '1vw',
                                width: '100%',
                                paddingX: '1rem',
                                marginTop: '1vh'
                            }}
                        >
                            <button className='btn-home-start btn-choose-language' onClick={() => changeLanguage('es')}>
                                Español
                            </button>
                            <button className='btn-home-start btn-choose-language' onClick={() => changeLanguage('en')}>
                                English
                            </button>
                        </Box>
                        <ListItem key='Reset' disablePadding onClick={resetApp}>
                            <ListItemButton>
                                <i className="fa-solid fa-rotate-right"></i>
                                <ListItemText primary={t('App.Components.reset')} primaryTypographyProps={{ fontSize: 'min(2.4vh, 2.4vw)', fontWeight: 300 }}/>
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Box>
            </Drawer>
        </>
    )
})
